import { render } from "./ui-image.vue?vue&type=template&id=903ecb9e&scoped=true&ts=true"
import script from "./ui-image.vue?vue&type=script&lang=ts"
export * from "./ui-image.vue?vue&type=script&lang=ts"

import "./ui-image.vue?vue&type=style&index=0&id=903ecb9e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/1fe6d5c2-02f8-4b7b-a7ed-3827401bba29/workspace/toilet-go-front_Ak2Q/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-903ecb9e"]])

export default __exports__